import api from './api';

const permisosService = {

  // Obtener tipos de permiso disponibles (auxiliar para selects)
  async getTiposPermiso() {
    try {
      const response = await api.get('/permisos/tipos-permiso');
      return response.data;
    } catch (error) {
      console.error('Error al obtener tipos de permiso:', error);
      throw error;
    }
  },

  // Obtener balance de permisos de un empleado
  async getBalanceEmpleado(empleadoID, anio = null) {
    try {
      const url = anio
        ? `/permisos/balance/${empleadoID}?anio=${anio}`
        : `/permisos/balance/${empleadoID}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error al obtener balance de permisos:', error);
      throw error;
    }
  },

  // RRHH: obtener balance de todos los empleados
  async getBalanceTodos(anio = null, tipoPermiso = null) {
    try {
      const params = new URLSearchParams();
      if (anio) params.append('anio', anio);
      if (tipoPermiso) params.append('tipoPermiso', tipoPermiso);
      const query = params.toString() ? `?${params.toString()}` : '';
      const response = await api.get(`/permisos/balance${query}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener balance general de permisos:', error);
      throw error;
    }
  },

  // RRHH: ajuste manual (descuento o crédito)
  // operacion: 'descuento' | 'credito'
  async ajusteManual({ empleadoID, tipoPermiso, dias, operacion, observaciones, dthsID }) {
    try {
      const response = await api.post('/permisos/balance/ajuste', {
        empleadoID,
        tipoPermiso,
        dias,
        operacion,
        observaciones,
        dthsID
      });
      return response.data;
    } catch (error) {
      console.error('Error al aplicar ajuste manual de permisos:', error);
      throw error;
    }
  },

  // RRHH: registrar permiso médico o licencia
  async crearPermisoMedicoLicencia({ empleadoID, tipoPermiso, dias, observaciones }) {
    try {
      const response = await api.post('/permisos/balance/medico-licencia', {
        empleadoID,
        tipoPermiso, // 'medico' | 'licencia'
        dias,
        observaciones
      });
      return response.data;
    } catch (error) {
      console.error('Error al registrar permiso médico/licencia:', error);
      throw error;
    }
  }

};

export default permisosService;